(function () {
  function init(root) {
    const body = root.querySelector('[data-product-description-body]');
    const btn = root.querySelector('[data-read-more-btn]');
    const moreLabel = btn && btn.querySelector('[data-read-more-label]');
    const lessLabel = btn && btn.querySelector('[data-read-less-label]');
    if (!body || !btn || !moreLabel || !lessLabel) return;

    function setCollapsed() {
      root.removeAttribute('data-expanded');
      body.style.maxHeight = '';
      root.classList.remove('is-truncated');
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      moreLabel.classList.remove('hidden');
      lessLabel.classList.add('hidden');

      root.classList.add('is-truncated');
      const overflow = body.scrollHeight > body.clientHeight + 2;
      if (overflow) {
        btn.hidden = false;
      } else {
        root.classList.remove('is-truncated');
      }
    }

    function setExpanded() {
      root.setAttribute('data-expanded', 'true');
      body.style.maxHeight = '';
      btn.setAttribute('aria-expanded', 'true');
      moreLabel.classList.add('hidden');
      lessLabel.classList.remove('hidden');
    }

    btn.addEventListener('click', function () {
      if (root.getAttribute('data-expanded') === 'true') {
        setCollapsed();
      } else {
        setExpanded();
      }
    });

    function measure() {
      const wasExpanded = root.getAttribute('data-expanded') === 'true';
      if (wasExpanded) return;
      setCollapsed();
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        requestAnimationFrame(measure);
      });
    } else {
      requestAnimationFrame(measure);
    }

    let resizeTimer;
    window.addEventListener('resize', function () {
      if (root.getAttribute('data-expanded') === 'true') return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 150);
    });
  }

  function boot() {
    document.querySelectorAll('[data-product-description-expand]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
